import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router'
import { HttpClient } from '@angular/common/http';
import { bmxurl, getAccess } from 'src/globals';
import { extra_returndata } from 'src/types/extra_returndata';
import { extraoption_returndata } from 'src/types/extraoption_returndata';
import { Router } from '@angular/router';
import { cExtra, extra } from 'src/types/extra';
import { extraoption } from 'src/types/extraoption';
import { tag } from 'src/types/tag';
import { tag_returndata } from 'src/types/tag_returndata';
import { MessageService } from 'primeng/api';

import { users_returndata } from 'src/types/user_returndata';
import { GlobalService } from '../_services/global.service';
import { v4 as uuidv4 } from 'uuid';


@Component({
  selector: 'app-extraedit',
  templateUrl: './extraedit.component.html',
  styleUrls: ['./extraedit.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ExtraeditComponent implements OnInit {
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  Extra: cExtra;
  httpResponse: any;
  id: string;
  stateOptions: any;
  stateOptions2: any;
  stateOptions3: any;
  stateOptionsYesNo: any;

  pageReady: boolean = false;
  availableExtraOptions: extraoption[] = [];
  selectedExtraOptions: extraoption[] = [];
  draggedExtraOption: extraoption = null;

  extraNameValid: boolean = true;
  extraDescValid: boolean = true;

  questionValid: boolean = true;

  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;

  //Held as the API's own datetype, so the two cannot drift apart: ALLDAYS, CHOOSEDAYS or
  //SINGLEDATE.
  DayMode: string = "ALLDAYS";
  SingleDate: Date = null;
  singleDateValid: boolean = true;

  //A date is always sent, even when the extra does not run on one date. 01/01/1900 is how the API
  //reads "no date set".
  private readonly noDate: string = "1900-01-01T00:00:00.0000Z";

  askQuestion: boolean = false;

  CurrencySymbol: string = localStorage.getItem("Currency") == null ? "GBP" : localStorage.getItem("Currency")!;

  tags: tag[] = [];
  selectedTags: tag[] = [];

  // Image upload - the same imageupload endpoint the package editor uses. The
  // guid names the stored file, so replacing an image overwrites it rather
  // than leaving the old one behind.
  HTMLbmxurl: string = bmxurl;
  Identifier: string = uuidv4();
  FileChosen: string = "";

  constructor(private route: ActivatedRoute, private http: HttpClient, private router: Router, private messageService: MessageService, private globalService: GlobalService) {
    this.stateOptions = [{label: 'Off', value: false}, {label: 'On', value: true}];
    this.stateOptionsYesNo = [{label: 'Yes', value: true}, {label: 'No', value: false}];
    this.stateOptions2 = [{label: 'Per Extra', value: false}, {label: 'Per Booking', value: true}];
    this.stateOptions3 = [{label: 'All Days', value: "ALLDAYS"}, {label: 'Choose Days', value: "CHOOSEDAYS"}, {label: 'Single Date', value: "SINGLEDATE"}];

    this.Extra = {
      id: null,
      extraId: null,
      name: "",
      description: "",
      disabled: false,
      venueId: this.VenueID,
      monday: true,
      tuesday: true,
      wednesday: true,
      thursday: true,
      friday: true,
      saturday: true,
      sunday: true,
      extraOptions: [],
      tags: [],
      price: 0,
      perPerson: false,
      question: "",
      answer: "",
      venueextras: false,
      imageurl: "",
      imageguid: this.Identifier,
      datetype: "ALLDAYS",
      singledate: this.noDate,
      variablevalue: false
    }
   }

  ngOnInit(): void {

    this.globalService.setSmallScreenMenu(false);

    let userid = localStorage.getItem("SmartUserID");

    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse =  (response as users_returndata)
      if(this.httpResponse.succeeded)
      {
        let user = this.httpResponse.data;

        if(getAccess("EXTRAS", user)){
          this.AccessAllowed = true;

          
        this.id = this.route.snapshot.paramMap.get('id');
        if(this.id != "0")
        {
          this.pageReady = false;
          this.http.get(bmxurl + "extra/" + this.VenueID + "/" + this.id).subscribe(response => {
            this.httpResponse = (response as extra_returndata)
            if (this.httpResponse.succeeded)
            {
              this.Extra = {
                id: (this.httpResponse.data as cExtra).id,
                extraId: (this.httpResponse.data as cExtra).extraId,
                name: (this.httpResponse.data as cExtra).name,
                description: (this.httpResponse.data as cExtra).description,
                disabled: (this.httpResponse.data as cExtra).disabled,
                venueId: (this.httpResponse.data as cExtra).venueId,
                monday: (this.httpResponse.data as cExtra).monday,
                tuesday: (this.httpResponse.data as cExtra).tuesday,
                wednesday: (this.httpResponse.data as cExtra).wednesday,
                thursday: (this.httpResponse.data as cExtra).thursday,
                friday: (this.httpResponse.data as cExtra).friday,
                saturday: (this.httpResponse.data as cExtra).saturday,
                sunday: (this.httpResponse.data as cExtra).sunday,
                extraOptions: (this.httpResponse.data as cExtra).extraOptions,
                tags: (this.httpResponse.data as cExtra).tags,
                price: (this.httpResponse.data as cExtra).price,
                perPerson: (this.httpResponse.data as cExtra).perPerson,
                question: (this.httpResponse.data as cExtra).question,
                answer: (this.httpResponse.data as cExtra).answer,
                venueextras: (this.httpResponse.data as cExtra).venueextras,
                imageurl: (this.httpResponse.data as cExtra).imageurl ?? "",
                imageguid: (this.httpResponse.data as cExtra).imageguid,
                datetype: (this.httpResponse.data as cExtra).datetype ?? "",
                singledate: (this.httpResponse.data as cExtra).singledate ?? this.noDate,
                variablevalue: (this.httpResponse.data as cExtra).variablevalue == true
              }

              // Extras saved before images existed have no guid yet.
              if (!this.Extra.imageguid) {
                this.Extra.imageguid = uuidv4();
              }

              this.Identifier = this.Extra.imageguid;
              this.FileChosen = this.Extra.imageurl;

              const savedDate = this.readDate(this.Extra.singledate);
              const hasDate = savedDate != null && savedDate.getFullYear() > 1900;

              this.SingleDate = hasDate ? savedDate : null;

              //Open on whichever way the extra is actually set up. An extra saved before datetype
              //existed has nothing to go on, so it is read the way it always was: by its date if it
              //has a real one, otherwise by its days of the week.
              if(this.Extra.datetype == "ALLDAYS" || this.Extra.datetype == "CHOOSEDAYS" || this.Extra.datetype == "SINGLEDATE")
              {
                this.DayMode = this.Extra.datetype;
              }
              else if(hasDate)
              {
                this.DayMode = "SINGLEDATE";
              }
              else if(this.Extra.monday && this.Extra.tuesday && this.Extra.wednesday && this.Extra.thursday && this.Extra.friday && this.Extra.saturday && this.Extra.sunday)
              {
                this.DayMode = "ALLDAYS";
              }
              else
              {
                this.DayMode = "CHOOSEDAYS";
              }
    
              if(this.Extra.question != "" && this.Extra.question != null)
              {
                this.askQuestion = true;
              }
              
              this.pageReady = true;
            }
            else
            {
              this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting Extras'});
              this.pageReady = false;
            }
          }, error => {
            this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting Extas, error:' + error.messages[0]});
            this.pageReady = false;
          });
        }
        else
        {
          this.pageReady = true;
        }
    
        this.loadExtraOptions(false);
        this.loadTags(false);
        }

        this.CompletedLoading = true;

      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
    });


  }

RemoveFromList(product){
  this.Extra.extraOptions = this.Extra.extraOptions.filter(obj => obj.id !== product.id);
}

AddToList(product){
  if(this.Extra.extraOptions == null)
  {
    this.Extra.extraOptions = [];
    this.Extra.extraOptions.push(product);
  }
  else{
    this.Extra.extraOptions.push(product);
  }
}

loadExtraOptions(showdisabled: boolean)
  {
    this.http.get(bmxurl + "ExtraOptionList/" + this.VenueID + "/" + showdisabled).subscribe(response => {
      this.availableExtraOptions = (response as extraoption_returndata).data;


      this.selectedExtraOptions.forEach((value,index)=>{
        this.availableExtraOptions = this.availableExtraOptions.filter((val,i) => val.extraOptionID!=value.extraOptionID);
      });


    }, error => {
    });
}

//A variable value extra has no price of its own and is only ever added by staff, so turning
//the switch on makes it venue only (and that switch is then locked) and clears the price.
variableValueChanged()
  {
    if (this.Extra.variablevalue == true)
    {
      this.Extra.venueextras = true;
      this.Extra.price = 0;
    }
  }

updateData()
  {
    this.Extra.datetype = this.DayMode;

    //Enforced again on save, whatever the screen was left showing.
    this.variableValueChanged();

    //A single date decides on its own, so the days of the week are all left on and the date is
    //what the extra is judged by.
    if (this.DayMode != "CHOOSEDAYS")
    {
      this.Extra.monday = true;
      this.Extra.tuesday = true;
      this.Extra.wednesday = true;
      this.Extra.thursday = true;
      this.Extra.friday = true;
      this.Extra.saturday = true;
      this.Extra.sunday = true;
    }

    //Always a date, never nothing: 01/01/1900 where the extra does not run on a single date.
    if (this.DayMode == "SINGLEDATE" && this.SingleDate != null)
    {
      this.Extra.singledate = this.writeDate(this.SingleDate);
    }
    else
    {
      this.Extra.singledate = this.noDate;
    }

    if(this.DoValidCheck())
    {
    if (this.selectedExtraOptions.length > 0) {
      this.selectedExtraOptions.forEach((value,index)=>{
        value.sortorder = index;
      });
    }

    if(!this.askQuestion)
    {
      this.Extra.question = "";
    }

    if(this.Extra.question != null)
    {
      this.Extra.question = this.Extra.question.trim();
    }

    if(this.Extra.answer != null)
    {
      this.Extra.answer = this.Extra.answer.trim();
    }

    if(this.id=="0")
    {
      this.http.post<extra>(bmxurl + "/extra", this.Extra).subscribe(response => {
        this.httpResponse = response
        if(this.httpResponse.succeeded == true)
        {
          this.messageService.add({severity:'success', summary:'Saved', detail:'Extra successfully created'});
          this.router.navigateByUrl("/extra");
        }
      }, error => {
        this.messageService.add({severity:'error', summary:'Not Saved', detail:error.messages[0]});
      })
    }
    else
    {
      this.Extra.disabled = false;
      
      this.http.put<extra>(bmxurl + "/extra", this.Extra).subscribe(response => {
        this.httpResponse = response
        if(this.httpResponse.succeeded == true)
        {
          this.messageService.add({severity:'success', summary:'Saved', detail:'Extra successfully updated'});
          this.router.navigateByUrl("/extra");
        }
      }, error => {
        this.messageService.add({severity:'error', summary:'Not Saved', detail:error.messages});
      })
    }
  }
}

uploadedFile(event){
  this.Extra.imageurl = event.originalEvent.body.data;

  // Same file name as before when an image is replaced, so bust the cache or
  // the preview keeps showing the old one.
  this.FileChosen = event.originalEvent.body.data + "?n=" + uuidv4();
}

onErrorFileUpload(event){
  this.messageService.add({ severity: 'error', summary: 'Image not uploaded', detail: 'Could not upload image: ' + event.error });
}

removeImage(){
  this.FileChosen = "";
  this.Extra.imageurl = "";
}

//Read as the date written down rather than turned into local time, so a date saved as the 24th
//still reads as the 24th whatever the browser's timezone.
private readDate(value: string): Date
{
  if(value == null || value == "")
  {
    return null;
  }

  return new Date(Number(value.substring(0, 4)), Number(value.substring(5, 7)) - 1, Number(value.substring(8, 10)));
}

//Written the way the venue closings editor writes its dates: the day exactly as picked, at
//midnight, so it cannot slip to the day before when it is sent.
private writeDate(date: Date): string
{
  const picked = new Date(date);

  return picked.getFullYear() + "-" + ('00' + (picked.getMonth() + 1).toString()).slice(-2) + "-" + ('00' + picked.getDate().toString()).slice(-2) + "T00:00:00.0000Z";
}

DoValidCheck()
{
  let AllValid = true;

  if(this.DayMode == "SINGLEDATE" && this.SingleDate == null)
  {
    AllValid = false;
    this.singleDateValid = false;
  }
  else
  {
    this.singleDateValid = true;
  }

  if((this.Extra.question == null || this.Extra.question == "") && this.askQuestion)
  {
    AllValid = false;
    this.questionValid = false;
  }
  else
  {
    this.questionValid = true;
  }


  if(this.Extra.name == null || this.Extra.name == "")
  {
    AllValid = false;
    this.extraNameValid = false;
  }
  else
  {
    this.extraNameValid = true;
  }

  if(this.Extra.description == null || this.Extra.description == "")
  {
    AllValid = false;
    this.extraDescValid = false;
  }
  else
  {
    this.extraDescValid = true;
  }

  return AllValid;
}

loadTags(showdisabled: boolean) {
    this.http.get(bmxurl + "TagList/" + this.VenueID + "/" + showdisabled).subscribe(response => {
      this.tags = (response as tag_returndata).data;

    }, error => {
    });
}

returnToList()
  {
    this.router.navigateByUrl("/extra");
  }
}
